<template>
  <div class="hcl-product-create">
    <vh-form ref="productForm" :model="form" :rules="rules" label-width="100px">
      <vh-form-item label="商品名称" prop="name">
        <vh-input
          v-model.trim="form.name"
          v-clearEmoji
          :maxlength="30"
          autocomplete="off"
          show-word-limit
          placeholder="请输入商品名称"
        ></vh-input>
      </vh-form-item>
      <vh-form-item label="商品图片" prop="images">
        <div class="imgList">
          <div class="img-item" v-for="(item, index) in form.images" :key="index">
            <span class="cover-item" v-if="item.is_cover">封面</span>
            <upload
              v-model="item.img_url"
              :ref="`product_uploader${item.img_id}`"
              :domain_url="item.img_url"
              :saveData="saveImageData"
              :isProduct="true"
              :widthImg="148"
              :heightImg="148"
              :coverPic="!item.is_cover"
              @delete="formDelete(item)"
              @coverPage="coverPage(item)"
              :on-success="
                (res, file) => {
                  handleUploadSuccessProduct(item, res, file);
                }
              "
              :on-change="
                (file, fileList) => {
                  handleUploadChangeProduct(item, file, fileList);
                }
              "
              :auto-upload="false"
            >
              <p slot="tip">上传图片</p>
            </upload>
          </div>
          <div class="img-item" v-if="form.images.length < 4">
            <upload
              ref="product_uploaderdefault"
              :saveData="saveImageData"
              :isProduct="true"
              :on-success="
                (res, file) => {
                  handleUploadSuccessProduct('default', res, file);
                }
              "
              :on-change="
                (file, fileList) => {
                  handleUploadChangeProduct('default', file, fileList);
                }
              "
              :auto-upload="false"
            >
              <p slot="tip">上传图片</p>
            </upload>
          </div>
        </div>
        <p class="imgText">建议尺寸600*600，小于2M，支持jpg、gif、png、bmp</p>
      </vh-form-item>
      <vh-form-item label="商品描述" prop="description">
        <vh-input
          type="textarea"
          v-model="form.description"
          :maxlength="140"
          autocomplete="off"
          show-word-limit
          :autosize="{ minRows: 4 }"
          placeholder="请输入商品描述"
        ></vh-input>
      </vh-form-item>

      <vh-form-item label="购买方式" prop="url" key="key_buy_type">
        <vh-radio-group v-model="form.buy_type" @change="validateBuyType">
          <vh-radio :label="1">平台购买</vh-radio>
          <vh-radio :label="2">外链购买</vh-radio>
          <vh-radio :label="3">自定义购买(适用于嵌入到APP)</vh-radio>
          <vh-radio :label="4">跳转小程序购买</vh-radio>
        </vh-radio-group>
        <template v-if="form.buy_type === 1">
          <p class="buy-type-desc">
            1.请提供您的微信或支付宝商户号给到您的专属客服或客户经理，配置成功后方能使用平台购买方式
            <a
              class="color-0A7FF5"
              target="_blank"
              href="https://saas-doc.vhall.com/opendocs/show/1479"
            >
              查看详细说明
            </a>
            <br />
            2.将观看端嵌入到您的官网或其他页面，无法正常使用微信支付方式进行付款，观众进行商品购买时进行提示
            <br />
            3.将观看端嵌入到您的APP中，为保证观众可正常购买商品，需要您的开发人员进行基础开发
            <a
              class="color-0A7FF5"
              target="_blank"
              href="https://saas-doc.vhall.com/opendocs/show/1495"
            >
              查看技术文档
            </a>
          </p>
          <p class="buy-type-pay">
            <span>微信商户号</span>
            <span :class="parterObj.WEIXIN ? 'success' : 'fail'">
              {{ parterObj.WEIXIN ? '已完成接入' : '未接入' }}
            </span>
            <span class="ml24">支付宝商户号</span>
            <span :class="parterObj.ALIPAY ? 'success' : 'fail'">
              {{ parterObj.ALIPAY ? '已完成接入' : '未接入' }}
            </span>
          </p>
        </template>
        <p class="buy-type-desc pb-16" v-if="form.buy_type === 2">
          外链商品订单只支持在第三方平台查看，直播间无法追溯外链商品的购买情况
        </p>
        <p class="buy-type-desc" v-if="form.buy_type === 3">
          自定义购买方式的订单只支持在您的平台查看，直播间无法追溯商品的购买情况
        </p>
        <p class="buy-type-desc" v-if="form.buy_type === 4">
          商品订单只支持在第三方平台查看，直播间无法追溯购买情况
        </p>
        <vh-input
          v-if="form.buy_type === 2"
          v-model.trim="form.url"
          v-clearEmoji
          placeholder="请输入以http://或https://开头的商品链接"
          autocomplete="off"
        ></vh-input>
      </vh-form-item>
      <template v-if="form.buy_type === 4">
        <vh-form-item label="跳转方式">
          <vh-radio-group
            v-model="form.mini_program_config.mini_program_jump_type"
            @change="ChangeJumpType"
          >
            <vh-radio :label="0">小程序跳转（适用于观看端嵌入到小程序中）</vh-radio>
            <vh-radio :label="1">H5跳转小程序（适用于观看端非嵌入场景）</vh-radio>
          </vh-radio-group>
        </vh-form-item>
        <vh-form-item
          label="页面路径"
          prop="mini_program_config.mini_program_path"
          key="key_mini_program_path"
        >
          <vh-input
            v-model.trim="form.mini_program_config.mini_program_path"
            placeholder="请输入小程序页面路径，请和您的开发人员确认后进行填写"
            v-clearEmoji
            autocomplete="off"
            :maxlength="300"
          ></vh-input>
        </vh-form-item>
        <vh-form-item
          label="小程序ID"
          prop="mini_program_config.mini_program_id"
          key="mini_program_id"
          v-if="form.mini_program_config.mini_program_jump_type == 1"
        >
          <vh-input
            v-model.trim="form.mini_program_config.mini_program_id"
            placeholder="请输入小程序ID，请和您的开发人员确认后进行填写"
            v-clearEmoji
            autocomplete="off"
            :maxlength="300"
          ></vh-input>
        </vh-form-item>
      </template>
      <vh-form-item label="商品原价" prop="price">
        <vh-input
          v-model.trim="form.price"
          placeholder="请输入价格"
          autocomplete="off"
          :maxlength="10"
        >
          <i class="price-unit" slot="suffix">元</i>
        </vh-input>
      </vh-form-item>
      <vh-form-item label="优惠价" prop="discount_price">
        <vh-input
          v-model.trim="form.discount_price"
          placeholder="请输入价格"
          autocomplete="off"
          :maxlength="10"
        >
          <i class="price-unit" slot="suffix">元</i>
        </vh-input>
      </vh-form-item>
      <template v-if="form.buy_type === 3">
        <vh-form-item label="商品ID" prop="third_goods_id">
          <vh-input
            v-model="form.third_goods_id"
            autocomplete="off"
            placeholder="必填项，请输入您商品库里的商品ID"
          ></vh-input>
        </vh-form-item>
        <vh-form-item label="scheme地址" prop="scheme_template" v-if="form.buy_type === 3">
          <vh-input
            v-model.trim="form.scheme_template"
            placeholder="请输入scheme地址，可唤起您的APP订单页"
            autocomplete="off"
          ></vh-input>
          <a
            class="color-0A7FF5"
            target="_blank"
            href="https://saas-doc.vhall.com/opendocs/show/1496"
          >
            查看技术文档
          </a>
        </vh-form-item>
        <vh-form-item label="二维码" prop="qr_code_url" class="qrcode">
          <upload
            class="qrcode_uploader"
            ref="qrcode_uploader"
            v-model="form.qr_code_url"
            :heightImg="120"
            :domain_url="qrcodeUrl"
            :saveData="saveImageData"
            :on-success="uploadQrcodeSuccess"
            :on-change="
              (file, fileList) => {
                handleUploadChangeQrcode(form.qr_code_url, file, fileList);
              }
            "
            @delete="deleteUploadQrcode"
            :auto-upload="false"
          >
            <div slot="tip">
              <p>建议尺寸：320*320px，小于2M</p>
              <p>支持jpg、gif、png、bmp</p>
            </div>
          </upload>
          <vh-button
            style="vertical-align: super; margin-left: 8px"
            v-preventReClick
            type="text"
            @click="toDesc"
          >
            查看效果
          </vh-button>
          <p class="qrcode_desc">用户在浏览器中购买商品时，引导用户下载您的APP</p>
        </vh-form-item>
      </template>

      <template v-if="form.buy_type !== 4">
        <vh-form-item label="店铺入口" prop="shop_url" key="key_shop_url">
          <vh-radio-group @change="validateShopUrl" v-model="form.shop_show">
            <vh-radio :label="1">显示</vh-radio>
            <vh-radio :label="0">隐藏</vh-radio>
          </vh-radio-group>
          <br />
          <vh-input
            v-if="form.shop_show"
            v-model.trim="form.shop_url"
            v-clearEmoji
            placeholder="请输入以http://或https://开头的店铺链接"
            autocomplete="off"
          ></vh-input>
        </vh-form-item>
      </template>
      <vh-form-item>
        <vh-button type="primary" round class="length152" v-preventReClick @click="onSubmit">
          保存
        </vh-button>
      </vh-form-item>
    </vh-form>
    <!-- 裁剪组件 -->
    <img-cropper
      ref="productCropper"
      :currentMode="currentMode"
      @cropComplete="cropComplete"
      @resetUpload="resetChooseFile"
      :ratio="1"
    ></img-cropper>
    <!-- 二维码效果图 -->
    <vh-dialog
      title="示例效果"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="718px"
    >
      <img width="654" src="./img/qrdesc.png" alt="" />
    </vh-dialog>
  </div>
</template>
<script>
  import { clearEmoji, preventReClick } from '@vhcl/shared/directives';
  import { ImgCropper, Upload } from '@vhcl/tool-components';
  import {
    createAdminProduct,
    updateAdminProduct,
    getProductsPartner,
    getAdminProductDetail
  } from '../common/api/index';
  import {
    parseQueryString,
    buildUrlByMode,
    buildOssUploadProcessData,
    checkUploadType
  } from '@vhcl/shared/utils/tool';

  export default {
    name: 'ProductCreate',
    props: {
      // 编辑的商品id
      goods_id: {
        type: Number | String,
        required: false,
        default: ''
      }
    },
    directives: {
      clearEmoji,
      preventReClick
    },
    data() {
      return {
        isReset: false, // 是否是重置图片
        resetImgItem: {}, // 被重置的图片对象
        form: {
          images: [],
          description: '',
          buy_type: 2, // 1.平台购买 2.外链购买 3.自定义购买 4. 跳转小程序购买
          price: '', // 原价
          discount_price: '', //	优惠价
          shop_show: 0, // 显示店铺
          shop_url: '', // 店铺链接
          url: '', // 商品链接
          name: '', // 商品名称
          third_goods_id: '',
          scheme_template: '',
          qr_code_url: '',
          mini_program_config: {
            mini_program_id: undefined, // 小程序ID
            // mini_program_app_id: undefined, // 小程序APPID
            mini_program_jump_type: 0,
            mini_program_path: '' // 小程序路径
            // mini_program_ext: undefined // 扩展参数
          }
        },
        qrcodeUrl: '',
        parterObj: {
          WEIXIN: false,
          ALIPAY: false
        },
        dialogVisible: false,
        currentMode: 1, //默认图片裁切模式
        upload_process_data: '', //图片上传时的裁切数据
        rules: {}
      };
    },
    computed: {
      // 保存的上传图片的附加数据
      saveImageData() {
        let imageData = {
          path: 'webinars/spread-imgs',
          type: 'image'
        };
        if (this.upload_process_data) {
          imageData.process = this.upload_process_data;
        }
        return imageData;
      }
    },
    created() {
      if (this.goods_id) {
        this.getGoodInfo();
      }
      this.initRules();
      this.getPartner();
    },
    components: {
      ImgCropper,
      Upload
    },
    watch: {
      'form.price'(val) {
        val += '';
        this.form.price = val.match(/\d+(\.\d{0,2})?/) ? val.match(/\d+(\.\d{0,2})?/)[0] : '';
      },
      'form.discount_price'(val) {
        val += '';
        this.form.discount_price = val.match(/\d+(\.\d{0,2})?/)
          ? val.match(/\d+(\.\d{0,2})?/)[0]
          : '';
      },
      'form.buy_type': {
        handler(newValue, oldValue) {
          if (this.rules.price) {
            this.rules.price[0].required = newValue === 1;
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      validateBuyType() {
        // 触发验证
        if (this.form.buy_type == 1 || this.form.buy_type == 3 || this.form.buy_type == 4) {
          this.$refs.productForm.validateField('url');
        }
      },
      validateShopUrl() {
        // 触发验证
        // if (this.form.shop_url == 0) {
        //   this.$refs.productForm.validateField('shop_url');
        // }
      },
      getPartner() {
        getProductsPartner().then(res => {
          if (res.code == 200) {
            if (res.data.total) {
              res.data.list.forEach(item => {
                this.parterObj[item.channel] = true;
              });
            }
          } else {
            this.$vhMessage.error(res.msg);
          }
        });
      },
      // 验证商品链接和店铺链接
      linkCodeMatch(value) {
        let reg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+).*?/g;
        if (!reg.test(value)) {
          return false;
        } else {
          return true;
        }
      },
      getGoodInfo() {
        getAdminProductDetail({
          goods_id: this.goods_id
        })
          .then(res => {
            console.log('res.data:', res.data);
            this.form = {
              ...this.form,
              ...res.data
            };
            if (!this.form.mini_program_config) {
              this.$set(this.form, 'mini_program_config', {
                mini_program_path: '',
                mini_program_jump_type: 0
              });
            } else {
              this.form.mini_program_config.mini_program_jump_type = this.form.mini_program_config
                .mini_program_jump_type
                ? Number(this.form.mini_program_config.mini_program_jump_type)
                : 0;
            }
            console.log('this.form:', this.form);
            this.qrcodeUrl = res.data.qr_code_url;
            this.form.description = this.replaceHtml(this.form.description);
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 商品上传成功回调
       * @param {any} item
       * @param {any} res
       * @param {any} file
       * @returns {any}
       */
      handleUploadSuccessProduct(item, res, file) {
        if (res.data) {
          this.inputsBlur();
          let domain_url = buildUrlByMode(res.data.domain_url, this.currentMode);
          this.updateImgList(item, domain_url);
        }
      },
      /**
       * 商品图片本地裁剪预览
       * @param {*} file
       * @param {*} fileList
       */
      handleUploadChangeProduct(item, file, fileList) {
        console.log('handleUploadChangeProduct----->', item, file, fileList);

        if (file.status == 'ready') {
          // 还原当前的裁切图片展示方式
          if (item != 'default') {
            let urlParams = parseQueryString(item.img_url);
            if (urlParams.mode) {
              this.currentMode = urlParams.mode;
            }
          } else {
            this.currentMode = 1;
          }

          checkUploadType(file.raw, this, 1, 2, () => {
            let reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = e => {
              if (item != 'default') {
                this.$refs.productCropper.showModel(e.target.result, item.img_id);
              } else {
                this.$refs.productCropper.showModel(e.target.result, item);
              }
            };
          });
        }
      },
      // 删除
      formDelete(opt) {
        this.form.images.map((item, index) => {
          if (item.img_id === opt.img_id) {
            this.form.images.splice(index, 1);
          }
        });
        let length = this.form.images.length;
        if (length > 0 && opt.is_cover) {
          this.form.images[length - 1].is_cover = 1;
        }
      },
      coverPage(item) {
        this.form.images.map(item => (item.is_cover = 0));
        item.is_cover = 1;
      },
      /**
       * 更新对应的商品图片数据地址
       * @param {any} image_url
       * @returns {any}
       */
      updateImgList(currentItem, image_url) {
        if (currentItem != 'default') {
          // 如果是重置图片
          this.form.images.map((item, index) => {
            if (item.img_id == currentItem.img_id) {
              item.img_url = image_url;
              item.is_cover = currentItem.is_cover;
              item.img_id = currentItem.img_id;
            }
          });
        } else {
          this.form.images.push({
            img_url: image_url,
            is_cover: 0,
            img_id: new Date().getTime()
          });
        }
        if (!this.form.images.some(item => item.is_cover)) {
          this.form.images[0].is_cover = 1;
        }

        // 触发验证
        this.$refs.productForm.validateField('images');
      },
      replaceHtml(str) {
        let desc = null;
        desc = str.replace(/gt/gi, '');
        desc = desc
          .replace(/<[^<>&]+>/g, '')
          .replace(/&(lt|gt|nbsp|amp|quot|middot);/gi, '')
          .replace(/(\r\n)|(\n)/g, '');
        return desc;
      },
      createOrUpdate(obj) {
        if (this.goods_id) {
          return updateAdminProduct(obj);
        }
        return createAdminProduct(obj);
      },
      onSubmit() {
        this.$refs['productForm'].validate(async valid => {
          if (valid) {
            this.form.description = this.replaceHtml(this.form.description);
            this.form.name = this.replaceHtml(this.form.name);
            const obj = {
              ...this.form
            };
            if (this.form.price === '' && this.form.discount_price === '') {
              const action = await this.$vhConfirm(
                '当前商品原价和优惠价均未填写，确定保存？',
                '提示',
                {
                  dangerouslyUseHTMLString: true,
                  roundButton: true,
                  customClass: 'zdy-message-box',
                  lockScroll: false
                }
              )
                .then(() => true)
                .catch(() => false);
              if (!action) {
                return false;
              }
            }
            this.createOrUpdate(obj)
              .then(res => {
                if (res.code == 200) {
                  this.$vhMessage({
                    message: this.goods_id ? '修改成功' : '创建成功',
                    showClose: true,
                    type: 'success',
                    customClass: 'zdy-info-box'
                  });
                  this.$emit('success', res.data);
                } else if (res.code == 530071) {
                  this.$vhConfirm(
                    '您的支付信息还未录入成功，请联系您的专属客服或经理。<br>客服电话：400-888-9970',
                    '提示',
                    {
                      dangerouslyUseHTMLString: true,
                      showCancelButton: false,
                      confirmButtonText: '我知道了',
                      roundButton: true,
                      customClass: 'zdy-message-box',
                      lockScroll: false,
                      confirmButtonPosition: 'left'
                    }
                  );
                } else {
                  this.$vhMessage({
                    message: res.msg || (this.goods_id ? '修改失败' : '创建失败'),
                    showClose: true,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                }
              })
              .catch(res => {
                this.$vhMessage({
                  message: res.msg || (this.goods_id ? '修改失败' : '创建失败'),
                  showClose: true,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          } else {
            this.$vhMessage({
              message: `商品信息填写错误，请检查`,
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
        });
      },

      /**
       * 裁切组件内重新选择文件
       * @returns {any}
       */
      resetChooseFile(indexId) {
        if (indexId == 'qrcode') {
          this.$refs.qrcode_uploader.resetChooseFile();
        } else if (indexId == 'default') {
          this.$refs[`product_uploader${indexId}`].resetChooseFile();
        } else {
          this.$refs[`product_uploader${indexId}`][0].resetChooseFile();
        }
      },
      /**
       * 图片裁切完成后的回调函数
       * @param {any} cropperData
       * @param {any} url
       * @param {any} mode
       * @returns {any}
       */
      cropComplete(cropperData, url, mode, indexId, blurryDegree, lightDegree) {
        this.currentMode = mode;

        if (cropperData) {
          this.upload_process_data = buildOssUploadProcessData({
            cropperData: cropperData
            // blurryDegree: blurryDegree,
            // lightDegree: lightDegree
          });
        } else {
          this.upload_process_data = '';
        }

        this.$nextTick(() => {
          if (indexId == 'qrcode') {
            this.$refs.qrcode_uploader.upload();
          } else if (indexId == 'default') {
            this.$refs[`product_uploader${indexId}`].upload();
          } else {
            this.$refs[`product_uploader${indexId}`][0].upload();
          }
        });
      },
      toDesc() {
        this.dialogVisible = true;
      },
      deleteUploadQrcode() {
        this.form.qr_code_url = '';
        this.qrcodeUrl = '';
      },

      /**
       * 二维码上传成功回调
       * @param {any} file
       */
      uploadQrcodeSuccess(res, file) {
        if (res.data) {
          this.inputsBlur();
          this.qrcodeUrl = buildUrlByMode(res.data.domain_url, this.currentMode);
          this.form.qr_code_url = buildUrlByMode(res.data.domain_url, this.currentMode);
          this.$refs.productForm.validateField('qr_code_url');
        }
      },
      /**
       * 图片本地裁剪预览
       * @param {*} file
       * @param {*} fileList
       */
      handleUploadChangeQrcode(qr_code_url, file, fileList) {
        console.log('handleUploadChangeQrcode----->', qr_code_url, file, fileList);

        if (file.status == 'ready') {
          if (qr_code_url) {
            let urlParams = parseQueryString(qr_code_url);
            if (urlParams.mode) {
              this.currentMode = urlParams.mode;
            }
          }

          checkUploadType(file.raw, this, 1, 2, () => {
            let reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = e => {
              this.$refs.productCropper.showModel(e.target.result, 'qrcode');
            };
          });
        }
      },
      inputsBlur() {
        document.querySelectorAll('input').forEach(item => item.blur());
        document.querySelectorAll('textarea').forEach(item => item.blur());
      },
      initRules() {
        // 商品图片验证
        const imgValidate = (rule, value, callback) => {
          if (value && value.length === 0) {
            callback(new Error('请选择图片'));
          } else {
            callback && callback();
          }
        };
        // 商品名称长度
        const nameValidate = (rule, value, callback) => {
          if (!value) {
            callback(new Error('请输入商品名称'));
          } else {
            if (value.length > 30) {
              callback && callback('商品名称不能大于 30 个字符');
            } else {
              callback && callback();
            }
          }
        };
        // 商品链接
        const linkValidate = (rule, value, callback) => {
          if (!value) {
            if (this.form.buy_type == 2) {
              callback(new Error('请输入商品链接'));
            } else {
              callback();
            }
          } else {
            if (!this.linkCodeMatch(value)) {
              callback && callback('请输入以http://或https://开头的商品链接地址');
            } else {
              callback();
            }
          }
        };
        // 店铺链接
        const shopValidate = (rule, value, callback) => {
          if (value) {
            if (!this.linkCodeMatch(value)) {
              callback && callback('请输入以http://或https://开头的店铺链接地址');
            } else {
              callback();
            }
          } else {
            if (this.form.shop_show) {
              callback('请输入店铺链接');
            } else {
              callback();
            }
          }
        };
        // 商品原价
        const priceValidate = (rule, value, callback) => {
          if (this.form.buy_type === 1 && value === '') {
            callback(new Error('请输入商品原价'));
          } else {
            if (value === '') {
              callback();
              return;
            }
            if (value < 0 || value > 100000) {
              callback && callback('价格必须大于等于0且小于等于100000.00');
            } else {
              callback();
            }
          }
        };
        // 商品优惠价
        const priceCountValidate = (rule, value, callback) => {
          if (value) {
            if (value < 0 || value > 100000) {
              callback && callback('价格必须大于等于0且小于等于100000.00');
            } else {
              if (this.form.price && value - this.form.price > 0) {
                callback && callback('商品优惠价必须小于或等于商品原价');
              } else {
                callback();
              }
            }
          } else {
            callback();
          }
        };

        // 自定义链接
        const schemeValidate = (rule, value, callback) => {
          if (value) {
            callback();
          } else {
            if (this.form.buy_type == 3) {
              callback('请输入scheme地址');
            } else {
              callback();
            }
          }
        };

        // 商品id
        const goodsIdValidate = (rule, value, callback) => {
          if (value) {
            callback();
          } else {
            if (this.form.buy_type == 3) {
              callback('请输入商品ID');
            } else {
              callback();
            }
          }
        };

        // 二维码
        const qrcodeValidate = (rule, value, callback) => {
          if (value) {
            callback();
          } else {
            if (this.form.buy_type == 3) {
              callback('请选择二维码图片');
            } else {
              callback();
            }
          }
        };
        // 小程序参数校验
        const miniProgramPathValidate = (rule, value, callback) => {
          if (this.form.buy_type === 4 && !value) {
            callback(new Error('请输入小程序页面路径'));
          } else {
            if (value && value.length > 300) {
              callback && callback('小程序页面路径长度不超过300字符');
            } else {
              callback();
            }
          }
        };

        this.rules = {
          order_num: [
            { required: true, message: '请输入商品排序', trigger: 'blur' },
            {
              type: 'number',
              min: 0,
              max: 9999,
              message: '商品排序必须为0-9999数字值',
              trigger: 'blur'
            }
          ],
          name: [{ required: true, validator: nameValidate, trigger: 'blur' }],
          images: [{ required: true, validator: imgValidate, trigger: 'change' }],
          description: [{ required: true, message: '请输入商品描述', trigger: 'blur' }],
          price: [{ required: false, validator: priceValidate, trigger: 'blur' }],
          discount_price: [{ required: false, validator: priceCountValidate, trigger: 'blur' }],
          url: [{ required: true, validator: linkValidate, trigger: 'blur' }],
          shop_url: [{ required: false, validator: shopValidate, trigger: 'blur' }],
          scheme_template: [{ required: true, validator: schemeValidate, trigger: 'blur' }],
          third_goods_id: [{ required: true, validator: goodsIdValidate, trigger: 'blur' }],
          qr_code_url: [{ required: true, validator: qrcodeValidate, trigger: 'blur' }],
          'mini_program_config.mini_program_path': [
            { required: true, validator: miniProgramPathValidate, trigger: 'blur' }
          ],
          'mini_program_config.mini_program_id': [
            { required: true, message: '请输入小程序ID', trigger: 'blur' }
          ]
        };
      }
    }
  };
</script>
<style lang="less" scoped>
  .hcl-product-create {
    background: #fff;
    padding: 48px 32px 1px 32px;
    border-radius: 4px;
    ::v-deep .vh-card__body {
      padding: 48px;
    }

    ::v-deep .vh-input,
    .vh-textarea {
      width: 640px;
    }

    .add-product {
      background: #fff;
      padding: 48px 32px 1px 32px;
      border-radius: 4px;
    }

    .price-unit {
      font-style: normal;
      padding: 0 10px;
      color: #666;
    }

    ::v-deep .vh-upload--picture-card {
      height: 148px;
      .box > div {
        height: 148px;
      }
      .mask {
        span {
          &:nth-child(2) {
            margin: 0 10px;
            i {
              line-height: 1;
            }
          }
        }
      }
    }

    .qrcode_uploader {
      width: 360px;
      display: inline-block;
      ::v-deep .vh-upload--picture-card {
        height: 130px;
        .box > div {
          height: 130px;
        }
      }
    }
    .qrcode_desc {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      line-height: 22px;
      margin-top: -10px;
    }

    .buy-type-desc {
      font-size: 14px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 4px;
      &.pb-16 {
        padding-bottom: 16px;
      }
    }
    .color-0A7FF5 {
      color: #0a7ff5;
      margin-left: 12px;
    }

    .buy-type-pay {
      font-size: 14px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 8px;
      .ml24 {
        margin-left: 24px;
      }
      .success {
        color: #0fba5a;
        margin-left: 6px;
      }
      .fail {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .imgList {
      display: flex;
      width: 640px;
      height: 150px;
      // justify-content: space-between;
      align-items: center;
      .img-item {
        width: 150px;
        height: 150px;
        border: 4px;
        position: relative;
        margin-right: 15px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        .cover-item {
          z-index: 99;
          position: absolute;
          top: 0;
          left: 0;
          background: #fb3a32;
          border-radius: 4px 0 12px 0;
          color: #fff;
          font-size: 12px;
          display: inline-block;
          text-align: center;
          width: 40px;
          line-height: 22px;
          height: 22px;
        }
        img {
          width: 148px;
          height: 148px;
        }
        .hover-item {
          position: absolute;
          height: 150px;
          width: 150px;
          top: 0;
          left: 0;
          z-index: 10;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          i {
            font-size: 28px;
            color: #fff;
          }
        }
        &:hover .hover-item {
          display: block;
        }
      }
    }
    .imgText {
      color: #999;
      font-size: 14px;
      line-height: 25px;
    }
  }
</style>
